import { PRIMARY } from 'constants/colors';

import { brightness } from 'utils/misc';

import { Box, styled } from '@mui/material';

const GridStyleWrapper = styled(Box)(({ theme }) => ({
  '.MuiDataGrid-columnHeaders': {
    borderBottom: `2px solid ${theme.palette.primary.main}`
  },

  '.MuiDataGrid-row': {
    fontFamily: '"signikalight",Arial,sans-serif',
    '&:nth-of-type(odd):not(.Mui-selected)': {
      backgroundColor: theme.palette.action.hover
    }
  },
  '.MuiDataGrid-row:hover': {
    backgroundColor: 'inherit'
  },
  '.MuiTablePagination-root p': {
    margin: 0
  },

  '.MuiDataGrid-virtualScroller': {
    marginTop: '58px !important'
  },

  '.MuiDataGrid-cell--editing': {
    padding: '0 4px !important',
    backgroundColor: `${brightness(PRIMARY, 90)} !important`
  }
}));

export default GridStyleWrapper;
